var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.013 16.04a.88.88 0 0 1-.88.88H1.045a.88.88 0 0 1-.88-.88V6.784a.88.88 0 0 1 .339-.696L7.548.611a.88.88 0 0 1 1.081 0l7.044 5.478a.88.88 0 0 1 .34.696v9.254Zm-1.76-.881V7.215L8.088 2.42 1.925 7.215v7.944h12.327ZM3.685 11.636h8.805v1.762H3.686v-1.761Z",
    fill: "#03053D"
  })));
};

export default SvgHome;